export default {
  // 页面标题
  'pages.log.rawIngestion.title': '上传报文',
  'pages.log.rawIngestion.subtitle':
    '客户端上行数据的原始到达记录(收包即落袋,含畸形/被拒载荷);可查原始报文、下载原文、重载进同步管道',

  // 列表列
  'pages.log.rawIngestion.column.receivedAt': '到达时间',
  'pages.log.rawIngestion.column.receivedAtRange': '到达时间区间',
  'pages.log.rawIngestion.column.batchNo': '批次号',
  'pages.log.rawIngestion.column.batchNo.placeholder': '精确匹配',
  'pages.log.rawIngestion.column.batchNo.copy': '复制批次号',
  'pages.log.rawIngestion.column.batchNo.copied': '已复制',
  'pages.log.rawIngestion.column.endpoint': '上行入口',
  'pages.log.rawIngestion.column.tenant': '租户',
  'pages.log.rawIngestion.column.store': '门店',
  'pages.log.rawIngestion.column.tenant.placeholder': '请选择租户(可搜索)',
  'pages.log.rawIngestion.column.store.placeholder': '请选择门店(可搜索)',
  'pages.log.rawIngestion.column.store.placeholderFirst': '请先选择租户',
  'pages.log.rawIngestion.column.device': '设备',
  'pages.log.rawIngestion.column.device.copy': '复制设备ID',
  'pages.log.rawIngestion.column.device.copied': '已复制',
  'pages.log.rawIngestion.column.size': '报文大小',
  'pages.log.rawIngestion.column.uploadCount': '上传次数',
  'pages.log.rawIngestion.column.lastUploadedAt': '最后上传时间',
  'pages.log.rawIngestion.column.uploadCountMin': '上传次数大于',
  'pages.log.rawIngestion.column.uploadCountMin.placeholder':
    '请输入次数(严格大于)',
  'pages.log.rawIngestion.column.parseStatus': '处置状态',
  'pages.log.rawIngestion.column.rejectReason': '拒绝原因',
  'pages.log.rawIngestion.column.action': '操作',

  // 通用占位/提示
  'pages.log.rawIngestion.placeholder.select': '请选择',
  'pages.log.rawIngestion.tooltip.nameNotBackfilled': '名称未回填',
  'pages.log.rawIngestion.tooltip.uploadCountRepeat':
    '同一载荷已被上传 {count} 次,疑似客户端异常重传',

  // 上行入口双语名(行渲染字典,全量含已停收端点:2026-10-20 收窄后仅订单批/
  // 运营批 v1+v2 四入口继续落两层记录,存量历史行仍渲染至 90 天留存期衰减,
  // 词条保留供历史行显双语名;批次状态 GET 为动态路径段,仅标签回落不在下拉)。
  // 筛选下拉只出上述仍收包四入口——见 index.tsx endpointFilterEnum(2026-10-24
  // 同步收窄保留面),不要把已停收词条加回下拉
  'pages.log.rawIngestion.endpoint.orderBatch': '订单批',
  'pages.log.rawIngestion.endpoint.operationalBatch': '运营批',
  'pages.log.rawIngestion.endpoint.memberLogs': '会员日志',
  'pages.log.rawIngestion.endpoint.mallUpload': '商城上传',
  'pages.log.rawIngestion.endpoint.orderBatchV2': '订单批(v2)',
  'pages.log.rawIngestion.endpoint.orderBatchResetV2': '订单批重置(v2)',
  'pages.log.rawIngestion.endpoint.orderBatchStatusGetV2': '订单批状态查询(v2)',
  'pages.log.rawIngestion.endpoint.operationalBatchV2': '运营批(v2)',
  'pages.log.rawIngestion.endpoint.operationalBatchStatusGetV2':
    '运营批状态查询(v2)',
  'pages.log.rawIngestion.endpoint.memberLogsV2': '会员日志(v2)',
  'pages.log.rawIngestion.endpoint.dataSyncStrategyV2': '数据同步策略(v2)',
  'pages.log.rawIngestion.endpoint.dataSyncSyncPageV2': '数据同步分页(v2)',
  'pages.log.rawIngestion.endpoint.mallConfigV2': '商城配置(v2)',
  'pages.log.rawIngestion.endpoint.mallMergedVersionV2': '合并包版本(v2)',
  'pages.log.rawIngestion.endpoint.mallMergedMetaV2': '合并包元数据(v2)',
  'pages.log.rawIngestion.endpoint.mallMergedDownloadV2': '合并包下载(v2)',
  'pages.log.rawIngestion.endpoint.mallUploadV2': '商城上传(v2)',
  'pages.log.rawIngestion.endpoint.mallSmLinesV2': 'SM明细上传(v2)',
  'pages.log.rawIngestion.endpoint.heartbeatV2': '设备心跳(v2)',
  'pages.log.rawIngestion.endpoint.checkUpdateV2': '检查更新(v2)',

  // 处置状态选项(英文与后端 enumPick 同源)
  'pages.log.rawIngestion.parseStatus.captured': '已收包',
  'pages.log.rawIngestion.parseStatus.accepted': '已受理',
  'pages.log.rawIngestion.parseStatus.rejected': '已拒绝',
  'pages.log.rawIngestion.parseStatus.error': '处理异常',

  // 操作
  'pages.log.rawIngestion.action.detail': '详情',
  'pages.log.rawIngestion.action.reload': '重载',
  'pages.log.rawIngestion.action.reload.confirmTitle': '重载确认',
  'pages.log.rawIngestion.action.reload.confirmDesc':
    '将取原始报文原样重放进同步管道(仅订单批/运营批可用),是否继续?',
  'pages.log.rawIngestion.action.reload.tip': '重放进同步管道(按批次号幂等)',
  'pages.log.rawIngestion.action.reload.unsupported': '该端点不支持重载',

  // 消息
  'pages.log.rawIngestion.msg.loadDetailFailed': '加载详情失败',
  'pages.log.rawIngestion.msg.downloadFailed': '下载失败',
  'pages.log.rawIngestion.msg.batchReloadFailed': '批量重载请求失败',
  'pages.log.rawIngestion.msg.reloadSuccess':
    '重载成功(批次号 {batchNo},新到达行 {id})',
  'pages.log.rawIngestion.msg.replayResponse': '重放响应:code={code} {msg}',
  'pages.log.rawIngestion.msg.unknownId': '未知',

  // 详情抽屉
  'pages.log.rawIngestion.drawer.title': '到达详情',
  'pages.log.rawIngestion.drawer.download': '下载原文',
  'pages.log.rawIngestion.drawer.loading': '加载中…',
  'pages.log.rawIngestion.detail.arrivalId': '到达ID',
  'pages.log.rawIngestion.detail.receivedAt': '到达时间',
  'pages.log.rawIngestion.detail.endpoint': '上行入口',
  'pages.log.rawIngestion.detail.tenant': '租户',
  'pages.log.rawIngestion.detail.store': '门店',
  'pages.log.rawIngestion.detail.posId': '设备ID',
  'pages.log.rawIngestion.detail.clientIp': '客户端IP',
  'pages.log.rawIngestion.detail.bodySize': '报文字节',
  'pages.log.rawIngestion.detail.uploadCount': '上传次数',
  'pages.log.rawIngestion.detail.lastUploadedAt': '最后上传时间',
  'pages.log.rawIngestion.detail.uploadHistory': '提交历史',
  'pages.log.rawIngestion.detail.parseStatus': '处置状态',
  'pages.log.rawIngestion.detail.sinkFile': '文件层定位',
  'pages.log.rawIngestion.detail.rejectReason': '拒绝原因',
  'pages.log.rawIngestion.detail.rawBody': '原始报文',
  'pages.log.rawIngestion.detail.copyTruncated':
    '复制预览段(已截断,全文请下载)',
  'pages.log.rawIngestion.detail.copyOriginal': '复制原始报文',
  'pages.log.rawIngestion.detail.copied': '已复制',
  'pages.log.rawIngestion.detail.truncatedTag': '超 64KB 已截断,全文请下载',
  'pages.log.rawIngestion.detail.binaryTag': '二进制载荷,请下载查看',
  'pages.log.rawIngestion.detail.noPreviewBinary': '二进制载荷无文本预览',
  'pages.log.rawIngestion.detail.noPreview':
    '无可预览原文(元数据行或文件已归档)',

  // ===== 批量重载(多选 + 工具栏按钮,逐条复用单条 reload 语义) =====
  'pages.log.rawIngestion.batchReload.button': '批量重载',
  'pages.log.rawIngestion.batchReload.maxHint':
    '一次最多批量重载 50 条,请减少选择后重试',
  'pages.log.rawIngestion.batchReload.nothingReloadable':
    '所选行均不支持重载(上行入口不在订单批/运营批闭集),请调整选择',
  'pages.log.rawIngestion.batchReload.confirmTitle': '批量重载确认',
  'pages.log.rawIngestion.batchReload.confirmContent':
    '已选 {total} 行,其中 {reloadable} 行可重载(入口为订单批/运营批);重放将按批次号幂等重进同步管道,并产生新的到达行与派生批次号。是否继续?',
  'pages.log.rawIngestion.batchReload.resultTitle': '批量重载结果',
  'pages.log.rawIngestion.batchReload.confirm': '确定',
  'pages.log.rawIngestion.batchReload.cancel': '取消',
  'pages.log.rawIngestion.batchReload.resultSummary':
    '成功 {success} 条 / 失败 {fail} 条',
  'pages.log.rawIngestion.batchReload.successHint':
    '重载成功会产生新的到达行与派生批次号,列表已刷新',
  // 失败明细弹层列(批次号为主展示键,id 为诊断辅助列)
  'pages.log.rawIngestion.batchReload.column.batchNo': '批次号',
  'pages.log.rawIngestion.batchReload.column.id': '到达ID',
  'pages.log.rawIngestion.batchReload.column.reason': '失败原因',
  'pages.log.rawIngestion.batchReload.failedTitle': '失败明细',
};
